import React from 'react';

import { Button, FormControl, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import AdminUsersContainer from '../AdminUsersContainer';
import AdminAuthContainer from '../AdminAuthContainer';
import Select from '../../../components/forms/Select';
import { UserRole } from '../constants/user-roles';
import Input from '../../../components/forms/Input';

const FirstRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
`;

const SecondRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

const StyledButton = styled(Button)`
    margin-right: auto;
`;

const StyledFormControl = styled(FormControl)`
    margin-left: 1rem;
    width: 200px;
`;

interface UsersAdminToolbarProps {
    searchText: string;
    handleChangeSearch: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
    handleChangeRoleFilter: (role: UserRole) => void;
    fullCount: number;
    filteredCount: number;
}

const UsersAdminToolbar: React.FC<UsersAdminToolbarProps> = ({ searchText, handleChangeSearch, handleChangeRoleFilter, fullCount, filteredCount }) => {
    const { t } = useTranslation('portal');
    const { users } = useContainer(AdminUsersContainer);
    const { authMode } = useContainer(AdminAuthContainer);

    const history = useHistory();
    const { path } = useRouteMatch();

    const renderCounter = () => {
        if (filteredCount !== fullCount) {
            return <Typography>{t('users.user-count', { filteredCount, fullCount })}</Typography>;
        }

        return null;
    };

    const handleRoleFilterChange = (event) => {
        handleChangeRoleFilter(event.target.value);
    };

    const renderFilterTools = () => {
        if (users?.length) {
            return (
                <>
                    <StyledFormControl>
                        <Input name='search' label={t('search-placeholder')} onChange={handleChangeSearch} value={searchText}></Input>
                    </StyledFormControl>
                    <StyledFormControl>
                        <Select name='role' label={t('users.role-filter')} onChange={handleRoleFilterChange}>
                            <MenuItem value='' selected>{t('users.role-filter-none')}</MenuItem>
                            <MenuItem value={UserRole.Admin}>{t('users.userRoles.admin')}</MenuItem>
                            <MenuItem value={UserRole.Teacher}>{t('users.userRoles.teacher')}</MenuItem>
                            <MenuItem value={UserRole.InstructionalDesigner}>{t('users.userRoles.instructional-designer')}</MenuItem>
                        </Select>
                    </StyledFormControl>
                </>
            );
        }

        return null;
    };

    const handleAddUser = () => {
        history.push(`${path}/add`);
    };

    return (
        <div>
            <FirstRow>
                {authMode === 'admin' ? <StyledButton onClick={() => handleAddUser()} variant='contained'>{t('users.actions.add-users')}</StyledButton> : <></>}
                {renderFilterTools()}
            </FirstRow>
            <SecondRow>
                {renderCounter()}
            </SecondRow>
        </div>

    );
};

export default UsersAdminToolbar;
